import { getPriceForSpecialization } from 'bundles/payments/promises/productPrices';

export default (s12nId: $TSFixMe) => {
  const promise = getPriceForSpecialization({ specializationId: s12nId });
  promise.done();
  return promise;
};
